import store from "../store/store";
import router from "../Router";

export default {
    handleError(err) {
        if (err.request.status == 401) {
            store.commit('auth/IS_NOT_LOGGEDIN');
            if (!store.state.auth.isUserLoggedIn()) router.push("/login");
        }

        if (err.request.status == 404) {
            router.push("/error-404");
        }

        if (err.request.status == 500) {
            router.push("/error-500");
        }

        if (err.request.status == 403) {
            router.push("/pages/not-authorized");
        }
    }
}